import React from 'react';
import { DialogTitle } from '@mui/material';
import { dialogTitleStyles } from '../../../constants/escalateQueryDialog';

/**
 * EscalateQueryDialogHeader Component
 * Dialog header with title
 */
const EscalateQueryDialogHeader = () => {
  return (
    <DialogTitle sx={dialogTitleStyles}>Escalate Query</DialogTitle>
  );
};

export default EscalateQueryDialogHeader;
